<template>
  <div class="information" v-if="event != null">
    <EventCircle :event="event" :events="events" :index="index"/>
    <EventLine :status="event.status_event" v-if="events[index + 1] != null"/>
    <div class="container-line-replace" v-else>.</div>
    <p class="title">{{event.name_key}}</p>      
  </div>    
</template>

<script>
  import EventCircle from './EventCircle.vue'
  import EventLine from './EventLine.vue'
  export default {
    props: {
      event: null,
      events: null,
      index: null
    },
    components: {
      EventCircle,
      EventLine
    }
  }
</script>

<style scoped>

</style>